import React from 'react';

export const tableRowHeightInRem = 3;
export const iconButtonWidthInRem = 3;
export const iconButtonOffset = -4.5;
export const iconButtonIconLengthInRem = 1.4;
export const iconButtonMidpointX = iconButtonWidthInRem / 2;
export const iconButtonIconRightX = iconButtonMidpointX + iconButtonIconLengthInRem / 2;
export const iconButtonMidpointY = tableRowHeightInRem / 2;
export const iconButtonIconTopY = iconButtonMidpointY - iconButtonIconLengthInRem / 2;
export const iconButtonIconBottomY = iconButtonMidpointY + iconButtonIconLengthInRem / 2;
export const svgWidthInRem = iconButtonWidthInRem;

export const treeLineStyle = {
  // stroke: 'red',
  stroke: '#d5dbdb',
  strokeWidth: 1,
  vectorEffect: 'non-scaling-stroke',
};

export const TreeLineModes = Object.freeze({
  Default: 0, // |-
  Vertical: 1, // |
  L: 2, // L
  UpsideDownL: 3,
  Top: 4,
  Right: 5,
  Bottom: 6,
  None: 7,
});

export const showTop = (mode) => {
  return (
    mode === TreeLineModes.Default ||
    mode === TreeLineModes.L ||
    mode === TreeLineModes.Vertical ||
    mode === TreeLineModes.Top
  );
};

export const showRight = (mode) => {
  return (
    mode === TreeLineModes.Default ||
    mode === TreeLineModes.L ||
    mode === TreeLineModes.UpsideDownL ||
    mode === TreeLineModes.Right
  );
};

export const showBottom = (mode) => {
  return (
    mode === TreeLineModes.Default ||
    mode === TreeLineModes.UpsideDownL ||
    mode === TreeLineModes.Vertical ||
    mode === TreeLineModes.Bottom
  );
};

/**
 * Creates a tree line.
 */
export default class TreeLine extends React.Component {
  render() {
    const { level, mode } = this.props;

    return (
      <div
        className="ui-util-mv-i-s"
        style={{
          left: level > 2 ? iconButtonOffset + 2 * (level - 2) + `rem` : iconButtonOffset + 2 * (level - 1) + `rem`,
          top: `-0.5rem`,
          height: `0rem`,
          position: 'relative',
        }}
      >
        <span style={{ marginLeft: `${iconButtonWidthInRem}rem` }} />

        <svg
          style={{
            position: 'absolute',
            top: 0,
            left: `1rem`,
            right: 0,
            bottom: 0,
            width: `${svgWidthInRem}rem`,
            height: `${tableRowHeightInRem}rem`,
          }}
          viewBox={`0 0 ${svgWidthInRem} ${tableRowHeightInRem}`}
        >
          {showTop(mode) && (
            <line
              x1={`${iconButtonMidpointX}`}
              y1="0"
              x2={`${iconButtonMidpointX}`}
              y2={`${iconButtonMidpointY}`}
              style={treeLineStyle}
            />
          )}
          {showBottom(mode) && (
            <line
              x1={`${iconButtonMidpointX}`}
              y1={`${tableRowHeightInRem}`}
              x2={`${iconButtonMidpointX}`}
              y2={`${iconButtonMidpointY}`}
              style={treeLineStyle}
            />
          )}
          {showRight(mode) && (
            <line
              x1={`${iconButtonMidpointX}`}
              y1={`${iconButtonMidpointY}`}
              x2={`${svgWidthInRem}`}
              y2={`${iconButtonMidpointY}`}
              style={treeLineStyle}
            />
          )}
        </svg>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/components/tree_line.js